<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="elevation-2">
              <title-bar></title-bar>
              <v-card-title>
                <v-row>
                  <v-col v-if="locations[0].length === 4" cols="12" md="12">
                    <v-card-title style="padding-bottom: 0"
                      >Broista around {{ locations[0] }}</v-card-title
                    >
                  </v-col>
                  <v-col v-else cols="12" md="12">
                    <span v-if="locations.length === 1">
                      <v-card-title style="padding-bottom: 0"
                        >Broista @ {{ locations[0] }}</v-card-title
                      >
                    </span>
                    <span v-else>
                      <v-card-title style="padding-bottom: 0"
                        >Broista @ {{ locations.length }} locations in
                        {{ locations[0].substring(0, 2) }}</v-card-title
                      >
                    </span>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div
                      class="subtitle-2 font-italic font-weight-light pl-4"
                      style="padding-top: 0"
                    >
                      Dutch Bros. Coffee includes both franchised and
                      company-owned locations, so your application may be
                      processed by different parties independently.
                    </div>
                    <v-card-title
                      class="primary--text text-h6 pl-4 font-weight-bold"
                      >PERSONAL INFORMATION</v-card-title
                    >
                  </v-col>
                </v-row>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="firstName"
                      :rules="nameRules"
                      label="First name"
                      prepend-inner-icon="person"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="lastName"
                      :rules="nameRules"
                      label="Last name"
                      prepend-inner-icon="person"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="preferedName"
                      label="Prefered Name"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      prepend-inner-icon="email"
                      required
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      type="phone"
                      v-model="phone"
                      :rules="phoneRules"
                      label="Phone Number"
                      prepend-inner-icon="phone_iphone"
                      v-mask="'(###)###-####'"
                      required
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      v-model="address"
                      label="Address"
                      prepend-inner-icon="house"
                      :rules="requiredRules"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      v-model="city"
                      label="City"
                      prepend-inner-icon="location_city"
                      :rules="requiredRules"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" lg="6">
                    <v-select
                      v-model="state"
                      :items="states"
                      item-text="name"
                      item-value="key"
                      menu-props="auto"
                      label="State"
                      hide-details
                      prepend-inner-icon="map"
                      single-line
                      :rules="requiredRules"
                      required
                      filled
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6" lg="6">
                    <v-text-field
                      v-model="zip"
                      label="Zip"
                      prepend-inner-icon="map"
                      v-mask="'#####'"
                      :rules="requiredRules"
                      required
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <hr />

                <p class="my-3" style="font-size: 16px">
                  Have you ever worked for Dutch Bros or any of its franchisees?
                </p>
                <v-radio-group
                  v-model="q.previous_employee"
                  row
                  :rules="requiredRules"
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-if="q.previous_employee == 'Yes'"
                  v-model="q.previous_employee_explaination"
                  prepend-icon="mdi-clipboard-text"
                  label="Please tell us more about where and when you worked with us before"
                ></v-text-field>

                <p class="my-3" style="font-size: 16px">
                  Are you under the age of 18?
                </p>
                <v-radio-group
                  v-model="q.under_eighteen"
                  row
                  :rules="requiredRules"
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>

                <p
                  v-if="q.under_eighteen == 'Yes'"
                  class="my-3"
                  style="font-size: 16px"
                >
                  If “yes” can you, after employment, show proof of age?
                </p>
                <v-radio-group
                  prepend-icon="mdi-clipboard-text"
                  v-if="q.under_eighteen == 'Yes'"
                  v-model="q.under_eighteen_proof"
                  row
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>

                <p class="my-3" style="font-size: 16px">
                  If hired, are you able to submit proof that you are legally
                  eligible for employment in the United States?
                </p>
                <v-radio-group v-model="q.legal_emp" row :rules="requiredRules">
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>

                <p class="my-3" style="font-size: 16px">
                  Do you have reliable transportation to and from work?
                </p>

                <v-radio-group
                  v-model="q.reliable_transportation"
                  row
                  :rules="requiredRules"
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn v-if="!company" color="secondary" @click="previous">
                  Previous
                </v-btn>
                <v-btn class="mr-5" color="primary" @click="formSubmit">
                  Next
                </v-btn>
              </v-card-actions>
              <footer-bar></footer-bar>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar },

  computed: {
    firstName: {
      get() {
        return this.$store.state.firstName;
      },
      set(value) {
        this.$store.commit("setFirstName", { firstName: value });
      },
    },
    lastName: {
      get() {
        return this.$store.state.lastName;
      },
      set(value) {
        this.$store.commit("setLastName", { lastName: value });
      },
    },
    preferedName: {
      get() {
        return this.$store.state.preferedName;
      },
      set(value) {
        this.$store.commit("setPreferedName", { preferedName: value });
      },
    },
    email: {
      get() {
        return this.$store.state.email;
      },
      set(value) {
        this.$store.commit("setEmail", { email: value });
      },
    },
    phone: {
      get() {
        return this.$store.state.phone;
      },
      set(value) {
        this.$store.commit("setPhone", { phone: value });
      },
    },
    address: {
      get() {
        return this.$store.state.address;
      },
      set(value) {
        this.$store.commit("setAddress", { address: value });
      },
    },
    city: {
      get() {
        return this.$store.state.city;
      },
      set(value) {
        this.$store.commit("setCity", { city: value });
      },
    },
    state: {
      get() {
        return this.$store.state.state;
      },
      set(value) {
        this.$store.commit("setState", { state: value });
      },
    },
    zip: {
      get() {
        return this.$store.state.zip;
      },
      set(value) {
        this.$store.commit("setZip", { zip: value });
      },
    },
    locations: {
      get() {
        return this.$store.state.locations;
      },
      set(value) {
        this.$store.commit("setLocations", { locations: value });
      },
    },
    company: {
      get() {
        return this.$store.state.company;
      },
    },
    // qs
    q: {
      get() {
        return this.$store.state.q;
      },
      set(value) {
        this.$store.commit("setQ", { q: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    valid: false,
    loading: true,
    nameRules: [
      (v) => !!v || "Your full name is required",
      (v) => v.length <= 50 || "Name must be less than 50 characters",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
        "E-mail must be valid",
    ],
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) =>
        /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(
          v
        ) || "Phone must be valid",
    ],
    requiredRules: [(v) => !!v || "This field is required"],
    states: [
      { name: "Alabama", key: "AL" },
      { name: "Alaska", key: "AK" },
      { name: "American Samoa", key: "AS" },
      { name: "Arizona", key: "AZ" },
      { name: "Arkansas", key: "AR" },
      { name: "California", key: "CA" },
      { name: "Colorado", key: "CO" },
      { name: "Connecticut", key: "CT" },
      { name: "Delaware", key: "DE" },
      { name: "District Of Columbia", key: "DC" },
      { name: "Federated States Of Micronesia", key: "FM" },
      { name: "Florida", key: "FL" },
      { name: "Georgia", key: "GA" },
      { name: "Guam", key: "GU" },
      { name: "Hawaii", key: "HI" },
      { name: "Idaho", key: "ID" },
      { name: "Illinois", key: "IL" },
      { name: "Indiana", key: "IN" },
      { name: "Iowa", key: "IA" },
      { name: "Kansas", key: "KS" },
      { name: "Kentucky", key: "KY" },
      { name: "Louisiana", key: "LA" },
      { name: "Maine", key: "ME" },
      { name: "Marshall Islands", key: "MH" },
      { name: "Maryland", key: "MD" },
      { name: "Massachusetts", key: "MA" },
      { name: "Michigan", key: "MI" },
      { name: "Minnesota", key: "MN" },
      { name: "Mississippi", key: "MS" },
      { name: "Missouri", key: "MO" },
      { name: "Montana", key: "MT" },
      { name: "Nebraska", key: "NE" },
      { name: "Nevada", key: "NV" },
      { name: "New Hampshire", key: "NH" },
      { name: "New Jersey", key: "NJ" },
      { name: "New Mexico", key: "NM" },
      { name: "New York", key: "NY" },
      { name: "North Carolina", key: "NC" },
      { name: "North Dakota", key: "ND" },
      { name: "Northern Mariana Islands", key: "MP" },
      { name: "Ohio", key: "OH" },
      { name: "Oklahoma", key: "OK" },
      { name: "Oregon", key: "OR" },
      { name: "Palau", key: "PW" },
      { name: "Pennsylvania", key: "PA" },
      { name: "Puerto Rico", key: "PR" },
      { name: "Rhode Island", key: "RI" },
      { name: "South Carolina", key: "SC" },
      { name: "South Dakota", key: "SD" },
      { name: "Tennessee", key: "TN" },
      { name: "Texas", key: "TX" },
      { name: "Utah", key: "UT" },
      { name: "Vermont", key: "VT" },
      { name: "Virgin Islands", key: "VI" },
      { name: "Virginia", key: "VA" },
      { name: "Washington", key: "WA" },
      { name: "West Virginia", key: "WV" },
      { name: "Wisconsin", key: "WI" },
      { name: "Wyoming", key: "WY" },
    ],
  }),
  props: {
    source: String,
  },

  methods: {
    formSubmit(e) {
      console.log(e);
      console.log(JSON.parse(JSON.stringify(this.$store.state)));
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$router.push({ name: "P2" });
      }
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "Home" });
    },
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
